<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M4.61782 6.41601L7.36101 9.01545L7.36101 2L8.63899 2L8.63899 9.01545L11.3822 6.41601L12.2857 7.27219L8 11.3333L3.71429 7.27219L4.61782 6.41601Z"
      fill="currentColor"
    />
    <path d="M3 12.6667V14H13V12.6667H3Z" fill="currentColor" />
  </svg>
</template>
